(function () {
  function isFullInViewport(el) {
    const rect = el.getBoundingClientRect();
    if (rect.top < 0) {
      return true;
    }

    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <=
        (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  document.addEventListener("scroll", function (event) {
    const comCircles = document.querySelectorAll(".mb-animation");

    for (let i = 0; i < comCircles.length; i++) {
      if (isFullInViewport(comCircles[i])) {
        comCircles[i].classList.add("in-viewport");
      } else {
        comCircles[i].classList.remove("in-viewport");
      }
    }
  });
})();
